<template slot-scope="scope">
  <!-- 弹窗 -->
      <dialogModel
        :title="title"
        :visible.sync="dialogVisible"
        @handleClose="handleClose"
        @handleOk="handleUnderstand"
      >
        <div v-if="title == '拒绝'" class="main-body">
          <div>
            <div class="cancel">{{ Instruction }}</div>
          </div>
        </div>
        <div v-else class="main-body">
          <div>
            <div class="iptNum">
              <div>
                {{
                  row.contactType == 0
                    ? "请输入要交换的手机号："
                    : "请输入要交换的微信号："
                }}
              </div>
              <el-input v-model="Number1" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>
export default {
  props: {
    dialogVisible: {},
    title: {},
    Instruction: {},
    row: {},
  },
  components: {},
  data() {
    return {
      Number1: "",
    };
  },
  computed: {},
  created() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleUnderstand() {
      if (this.Number1 === "" && this.title == "同意") {
        this.$tool.PromptBox("error", "交换内容不能为空");
      } else {
        this.$emit("handleUnderstand", this.Number1);
        this.Number1 = "";
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-input__inner {
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  border-radius: 5px;
  //   border-right: none;
}
.iptNum {
  width: 300px;
  margin: auto;
  margin-top: 15px;
  div {
    margin-bottom: 10px;
    font-size: 14px;
  }
}
.main-body {
  width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .cancel {
    text-align: center;
    height: 100px;
    line-height: 100px;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
